import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { Modal, ModalContent } from "@zapier/design-system";
import { useQuery as defaultUseQuery, useMutation as defaultUseMutation, } from "@apollo/react-hooks";
import { ErrorModalView, NudgeViewModalContent, } from "@zapier/upsells/esm/components";
import { UpgradeModalContext } from "@zapier/upsells/esm/contexts";
import { canUpgradeForReason } from "@zapier/upsells/esm/utils";
import { CelebrateModalView, ChangePlanModalView, ExtendTrialModalView, NudgeModalView, } from "./views";
export const MODAL_STATE = {
    celebrateTrial: "celebrateTrial",
    celebrateUpgrade: "celebrateUpgrade",
    error: "error",
    extendTrial: "extendTrial",
    nudge: "nudge",
    upgrade: "upgrade",
};
const DEFAULT_MODAL_WIDTH = "630px";
export const UpgradeModalLayout = ({ appName, onClose, onUpgradeFinish = () => {
}, shouldAutoUpgrade = true, upgradeReason, wasTriggeredByZapToggle = false, useQuery = defaultUseQuery, useMutation = defaultUseMutation, }) => {
    var _a;
    const { account, accountCurrency, canExtendTrial, destinationPlan, error, extendTrial, isLoading, } = useContext(UpgradeModalContext);
    const [modalState, setModalState] = useState(MODAL_STATE.nudge);
    useEffect(() => {
        if (error) {
            setModalState(MODAL_STATE.error);
        }
    }, [error]);
    const isCelebrationState = modalState === MODAL_STATE.celebrateTrial ||
        modalState === MODAL_STATE.celebrateUpgrade;
    if (isLoading ||
        !destinationPlan ||
        (!isCelebrationState &&
            !canUpgradeForReason({
                plan: account === null || account === void 0 ? void 0 : account.plan,
                upgradeReason,
            }))) {
        return null;
    }
    const onCloseWithReload = () => {
        onClose();
        window.location.href = window.location.origin + window.location.pathname;
    };
    const onExtendTrialClick = async () => {
        setModalState(MODAL_STATE.extendTrial);
    };
    const onExtendTrialComplete = async () => {
        try {
            await extendTrial();
            setModalState(MODAL_STATE.celebrateTrial);
        }
        catch {
            setModalState(MODAL_STATE.error);
        }
    };
    const onUpgradeClick = () => {
        setModalState(MODAL_STATE.upgrade);
    };
    const onUpgradeComplete = () => {
        onUpgradeFinish();
        setModalState(MODAL_STATE.celebrateUpgrade);
    };
    const celebrateButtonText = wasTriggeredByZapToggle
        ? "Back to Zap"
        : "Continue";
    const contentMap = {
        [MODAL_STATE.nudge]: (_jsx(NudgeViewModalContent, { children: _jsx(NudgeModalView, { appName: appName, canExtendTrial: canExtendTrial, destinationPlan: destinationPlan, onClose: onClose, onExtendTrialClick: onExtendTrialClick, onUpgradeClick: onUpgradeClick, upgradeReason: upgradeReason, wasTriggeredByZapToggle: wasTriggeredByZapToggle }) })),
        [MODAL_STATE.upgrade]: (_jsx(ModalContent, { maxWidth: "700px", children: _jsx(ChangePlanModalView, { accountCurrency: account === null || account === void 0 ? void 0 : account.currency, accountName: account === null || account === void 0 ? void 0 : account.name, accountOwnerEmail: (_a = account === null || account === void 0 ? void 0 : account.owner) === null || _a === void 0 ? void 0 : _a.email, destinationPlanName: destinationPlan === null || destinationPlan === void 0 ? void 0 : destinationPlan.name, onClose: onClose, onUpgradeComplete: onUpgradeComplete, useMutation: useMutation, useQuery: useQuery }) })),
        [MODAL_STATE.celebrateTrial]: (_jsx(ModalContent, { maxWidth: DEFAULT_MODAL_WIDTH, children: _jsx(CelebrateModalView, { buttonText: celebrateButtonText, celebrationType: "trial", onClose: onCloseWithReload }) })),
        [MODAL_STATE.celebrateUpgrade]: (_jsx(ModalContent, { maxWidth: DEFAULT_MODAL_WIDTH, children: _jsx(CelebrateModalView, { buttonText: celebrateButtonText, celebrationType: "upgrade", newPlan: account === null || account === void 0 ? void 0 : account.plan, onClose: onCloseWithReload }) })),
        [MODAL_STATE.error]: (_jsx(ModalContent, { maxWidth: DEFAULT_MODAL_WIDTH, children: _jsx(ErrorModalView, { eventName: "upgrade_modal_error_view", fullStoryEventName: "Viewed Upgrade Modal - Error View", message: error !== null && error !== void 0 ? error : "Please try again. If the problem persists, click the button below and we'll help you through it." }) })),
        [MODAL_STATE.extendTrial]: (_jsx(ModalContent, { maxWidth: DEFAULT_MODAL_WIDTH, children: _jsx(ExtendTrialModalView, { accountCurrency: accountCurrency, onClose: onCloseWithReload, onExtendTrial: onExtendTrialComplete, shouldAutoUpgrade: shouldAutoUpgrade, trialPlan: destinationPlan, upgradeReason: upgradeReason, useMutation: useMutation, useQuery: useQuery }) })),
    };
    const closeModal = modalState === MODAL_STATE.celebrateTrial ||
        modalState === MODAL_STATE.celebrateUpgrade
        ? onCloseWithReload
        : onClose;
    return _jsx(Modal, { onClosed: closeModal, children: contentMap[modalState] });
};

// @zapier/upsells@8.0.1 (466b4077f)
